import { render, staticRenderFns } from "./niitlel.vue?vue&type=template&id=8daef466&"
import script from "./niitlel.vue?vue&type=script&lang=js&"
export * from "./niitlel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports